import theme, {themeColors} from '../../theme/Theme';

export const useHandoverNoteStyles = () => ({
  previousNotesContainer: {
    padding: 20,
    flexShrink: 1,
    flexGrow: 0,
  },
  currentNoteTitle: {
    fontWeight: 'bold',
    fontSize: 20,
    marginBottom: 2,
    color: theme.palette.primary.main,
  },
  noteTitle: {
    fontWeight: 'bold',
    fontSize: theme.typography.h5.fontSize,
    marginBottom: 2,
    color: theme.palette.primary.main,
  },
  previousNoteWrapper: {
    width: '100%',
  },
  previousNoteTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    color: theme.palette.primary.main,
    background: theme.palette.grey[200],
    display: 'inline-block',
    padding: `${theme.spacing(0.25)} ${theme.spacing(1)}`,
    position: 'relative',
    left: theme.spacing(-1),
  },
  notesEditor: {
    width: '100%',
    border: `1px solid ${theme.palette.grey[400]}`,
    padding: theme.spacing(2),
    fontFamily: theme.typography.fontFamily,
    minHeight: 100,
  },
  title: {
    fontSize: 26,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginTop: 20,
    marginBottom: 20,
  },
  disabledMenu: {
    '&:hover': {
      '&&&': {
        color: theme.palette.secondary.main,
        cursor: 'normal',
      },
    },
  },
  menuRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 20,
    '& .MuiListItem-root': {
      width: 'auto',
    },
  },
  item: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomRightRadius: 8,
    marginBottom: 1,
    padding: `${theme.spacing(0.7)} ${theme.spacing(0.7)} ${theme.spacing(
      0.7
    )} ${theme.spacing(1.5)} `,
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.secondary.main,
    },
    '&.active': {
      color: theme.palette.secondary.main,
      backgroundColor: theme.palette.background.paper,
    },
    color: theme.palette.text.primary,
  },
  rowItem: {
    borderRadius: 2,
    marginBottom: 1,
    padding: 1,
    paddingRight: 0,
    cursor: 'pointer',
    color: themeColors.backgroundDark,
    display: 'flex',

    alignItems: 'flex-start',
    backgroundColor: theme.palette.grey[100],
  },
  itemText: {
    fontSize: 13,
    display: 'flex',
    flex: 1,
    textTransform: 'capitalize',
  },
  activeItem: {
    backgroundColor: themeColors.backgroundDark,
    color: themeColors.white,
  },
  table: {
    borderRadius: 12,
    minHeight: 600,
    border: 0,
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    '& .MuiDataGrid-columnsContainer': {
      borderTopLeftRadius: 12,
      fontSize: 13,
      borderTopRightRadius: 12,
      border: 0,
    },

    '& .MuiDataGrid-columnHeader': {
      borderWidth: 0,
      borderRight: 0,
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
    },

    '& .MuiDataGrid-menuIcon': {
      display: 'none',
    },
    '& .MuiDataGrid-row.MuiDataGrid-row.MuiDataGrid-row': {
      borderRadius: 4,
    },
    '& .MuiDataGrid-iconSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeader, .MuiDataGrid-cell': {
      borderRight: `1px solid transparent`,
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {},
    '& .MuiDataGrid-cell': {
      boxSizing: 'border-box',
      backgroundColor: `#fbfbfb`,
      borderBottom: `2px  solid ${theme.palette.background.paper}`,
      borderTop: `2px  solid ${theme.palette.background.paper}`,
      outline: 'none',
      paddingLeft: 0,
      paddingRight: 0,
      textAlign: 'center',
      borderRight: `1px solid ${theme.palette.grey[100]}`,
    },
    '& .MuiDataGrid-columnsContainer .MuiDataGrid-cell': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-columnHeaderDraggableContainer': {
      justifyContent: 'center',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: 0,
      flex: 'none',
      userSelect: 'none',
      position: 'relative',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
    '& .MuiDataGrid-columnHeaderTitleContainer .MuiDataGrid-iconButtonContainer': {
      position: 'absolute',
      right: -20,
      top: 0,
    },
    '& .MuiDataGrid-columnHeaderTitleContainer .MuiIconButton-sizeSmall': {
      padding: 0,
    },
    '& .MuiPaginationItem-root': {
      borderRadius: 0,
    },
  },
});
